export enum OrderResponseStatus {
  "NEW" = "NEW",
  "COMPLETED" = "COMPLETED",
  "INACTIVE" = "INACTIVE",
}

export const responseStatusArray: OrderResponseStatus[] = [
  OrderResponseStatus.NEW,
  OrderResponseStatus.COMPLETED,
  OrderResponseStatus.INACTIVE,
];

export const mapOrderResponseStatus: { [key in OrderResponseStatus]: string } =
  {
    [OrderResponseStatus.NEW]: "Chờ gửi đơn",
    [OrderResponseStatus.COMPLETED]: "Đã hoàn tất",
    [OrderResponseStatus.INACTIVE]: "Đang đóng băng",
  };

export const mapOrderResponseStatusToColor: {
  [key in OrderResponseStatus]: string;
} = {
  [OrderResponseStatus.NEW]: "secondary",
  [OrderResponseStatus.COMPLETED]: "success",
  [OrderResponseStatus.INACTIVE]: "danger",
};
